import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import proPropTypes from 'Utilities/proPropTypes';

import styles from './VehicleCardPlaceholderBox.module.scss';

const VehicleCardPlaceholderBox = ({ className, style }) => (
	<div className={cx(styles.vehicleCardPlaceholderBox, className)} style={style} />
);

VehicleCardPlaceholderBox.defaultProps = {
	className: '',
	style: {},
};

VehicleCardPlaceholderBox.propTypes = {
	className: proPropTypes.className,
	style: PropTypes.shape({}),
};

export default VehicleCardPlaceholderBox;
